// ============================================================================
// note-client-mod -- useNotebookMutations Hook
//
// 笔记本 CRUD mutations（创建/更新/删除）。
// ============================================================================
import { useState, useCallback } from 'react';
import { getNoteApiClient } from '../note-api-client.js';
export function useNotebookMutations() {
    const [mutating, setMutating] = useState(false);
    const [error, setError] = useState(null);
    const createNotebook = useCallback(async (params) => {
        setMutating(true);
        setError(null);
        try {
            return await getNoteApiClient().createNotebook(params);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : '创建笔记本失败');
            return null;
        }
        finally {
            setMutating(false);
        }
    }, []);
    const updateNotebook = useCallback(async (id, params) => {
        setMutating(true);
        setError(null);
        try {
            return await getNoteApiClient().updateNotebook(id, params);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : '更新笔记本失败');
            return null;
        }
        finally {
            setMutating(false);
        }
    }, []);
    const deleteNotebook = useCallback(async (id) => {
        setMutating(true);
        setError(null);
        try {
            await getNoteApiClient().deleteNotebook(id);
            return true;
        }
        catch (err) {
            setError(err instanceof Error ? err.message : '删除笔记本失败');
            return false;
        }
        finally {
            setMutating(false);
        }
    }, []);
    return { mutating, error, createNotebook, updateNotebook, deleteNotebook };
}
//# sourceMappingURL=use-notebook-mutations.js.map